import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Button } from 'react-bootstrap';
import AppTrackingTable from './AppTrackingTable';

export default class UserList extends Component {
  render() {
    return (
      <div>
        <h1>Tracking User List</h1>
        <AppTrackingTable />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/cms/tracking/AppTrackingList.js